import { openErrorDialog, } from 'console/dialogs/error/redux/actions';
import { getAPIErrorMessage } from 'api';
export const load_z3k_device_history_config = (device_id, config_history) => ({
    type: 'LOAD_DEVICE_CONFIG',
    device_id,
    config_history,
});
export const set_config_setting_state = (loading_state) => ({
    type: 'SET_LOADING_STATE',
    loading_state,
});
export const loadDeviceZ3kConfig = (device_id) => {
    return async (dispatch, getState, { api }) => {
        const response = await api.load_z3k_device_config_history(device_id);
        const z3k_config_history = response.config_history;
        dispatch(load_z3k_device_history_config(device_id, z3k_config_history));
    };
};
export const request_z3k_config_file_by_id_from_server = (device_id, config_id) => {
    return async (dispatch, getState, { api }) => {
        try {
            //  TODO: здесь в случае ошибки открывается просто окно с JSON ответом, что не хорошо
            //  TODO: Нужно сделать генерацию файла и складирование ее куда-нибудь (в монгу или редис) (тут так раз принимаем ошибки)
            //  TODO: А потом уже выгружаем готовый файл с сервера
            //@ts-ignore
            window.location = api.get_url('download_z3k_config_from_server', { device_id, config_id }, true);
        }
        catch (error) {
            dispatch(openErrorDialog({
                error_ui: getAPIErrorMessage(error, 'Ошибка при попытке выгрузить конфиг'),
                error,
            }));
        }
    };
};
export const set_z3k_config_to_device_from_history = (device_id, config_id) => {
    return async (dispatch, getState, { api }) => {
        try {
            dispatch(set_config_setting_state(true));
            await api.set_z3k_device_config_from_history(device_id, config_id);
        }
        catch (error) {
            dispatch(openErrorDialog({
                error_ui: getAPIErrorMessage(error, 'Ошибка при попытке установить конфиг'),
                error,
            }));
        }
        finally {
            dispatch(set_config_setting_state(false));
        }
    };
};
export const change_save_for_z3k_config_history = (device_id, config_id, flag) => {
    return async (dispatch, getState, { api }) => {
        try {
            await api.change_save_for_z3k_config_history(device_id, config_id, flag);
        }
        catch (error) {
            dispatch(openErrorDialog({
                error_ui: getAPIErrorMessage(error, 'Ошибка при попытке закрепить историю конфигурации'),
            }));
        }
    };
};
